module.exports = __webpack_public_path__ + "img/play-icon.c12fd98c.svg";